/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedClassRoomUserTypes200,
  GetApiV1ClassroomdisciplineSharedClassRoomUserTypes401,
  GetApiV1ClassroomdisciplineSharedClassRoomUserTypesQueryParams,
  GetApiV1ClassroomdisciplineSharedClassRoomUserTypesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassRoomUserTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedClassRoomUserTypesQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomUserTypesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedClassRoomUserTypes200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomUserTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedClassRoomUserTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomUserTypes401>;

export const getApiV1ClassroomdisciplineSharedClassRoomUserTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedClassRoomUserTypes200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomUserTypesQueryResponse>;
